import React, { ComponentProps } from 'react';

import { BaseButton } from '@common/components';

type BaseProps = ComponentProps<typeof BaseButton>;

// This component is mostly for semantics, you should be using
// it instead of the base button directly
export const SecondaryButton = (props: Omit<BaseProps, 'type'>) => (
  <BaseButton {...props}>{props.children}</BaseButton>
);
